module.exports = __webpack_public_path__ + "img/case_pic04.e26db969.png";